module.exports = __webpack_public_path__ + "static/media/font.2554f31c.woff";